import { render, staticRenderFns } from "./UserGridAffiliate.vue?vue&type=template&id=6e82cbdb&"
import script from "./UserGridAffiliate.vue?vue&type=script&lang=js&"
export * from "./UserGridAffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports